import { Container } from './styles';

export default function Chip(props) {
  return <Container color="secondary" {...props} />;
}
